import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class ForumTopicPost extends WebComponent {

  constructor(props) {
    super(props);
    this.textAfterChange = null;
    this.textBeforeChange = null;
    this.textTargetElement = null;
    this.forumList = null;
    this.handleToggle = this.handleToggle.bind(this);
  }

  didMount() {
    const {
      forumBodyClass,
      listHiddenClass,
      buttonAnswerTextElement,
    } = this.props;

    // eslint-disable-next-line prefer-destructuring
    this.textTargetElement = this.element.getElementsByTagName(buttonAnswerTextElement)[ 0 ];
    this.icon = this.element.querySelector('.svg-icon');
    this.textAfterChange = this.props.textAfterChange;
    this.textBeforeChange = this.textTargetElement.innerHTML;
    this.forumList = this.element.closest(`.${ forumBodyClass }`).nextElementSibling;

    /*if (this.forumList instanceof HTMLElement) {
      this.forumList.classList.add(listHiddenClass);
    }*/

    this.on('click', this.handleToggle);
  }

  willUnMount() {

  }

  handleToggle(e) {
    const {
      buttonActiveClass,
      listHiddenClass,
    } = this.props;

    e.preventDefault();
    this.forumList.classList.toggle(listHiddenClass);
    this.element.classList.toggle(buttonActiveClass);
    if (this.element.classList.contains(buttonActiveClass)) {
      this.textTargetElement.innerHTML = this.textAfterChange;
      this.icon.setAttribute('aria-label',this.textAfterChange);
      this.element.setAttribute('aria-expanded','true');
    } else {
      this.textTargetElement.innerHTML = this.textBeforeChange;
      this.icon.setAttribute('aria-label',this.textBeforeChange);
      this.element.setAttribute('aria-expanded','false');
    }
  }
}

ForumTopicPost.defaultProps = {
  buttonActiveClass: 'forum__btn-answer--active',
  buttonAnswerTextElement: 'span',
  forumBodyClass: 'forum__body',
  listHiddenClass: 'forum__list--hidden',
};

export default ForumTopicPost;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ForumTopicPost.js